import { httpService } from "utils";
import { DateObject } from "utils/DateObject";

import { IEReservationGroupElementDto } from "../dto/IEReservationGroupElementDto";
import { IEReservationGroupElement } from "../types/IEReservationGroupElement";

export const getGroups = (
  friendlyUrl: string
): Promise<IEReservationGroupElement[]> => {
  return httpService()
    .get<IEReservationGroupElementDto[]>(`/e-reservation/${friendlyUrl}/groups`)
    .then((data) => {
      return data.map((group) => {
        return {
          ...group,
          queueList: group.queueList?.map((queue) => {
            return {
              ...queue,
              firstAvailableIntervalDate:
                queue.firstAvailableIntervalDate &&
                queue.firstAvailableIntervalDate !== ""
                  ? DateObject(queue.firstAvailableIntervalDate)
                  : undefined,
            };
          }),
        };
      });
    });
};

export const getGroupsKey = () => "groups";
